import { FC } from 'react';
import { SummaryStatCard } from 'components/summary-stat-card/summary-stat-card';
import { formatNumber } from 'utils/number';
import type { ExpenseScenarioAggregations } from './types';
import styles from './summary-cards.module.scss';

export type SummaryCardType = 'last24h' | 'last7d' | 'lastMonth';

interface ExpenseScenariosSummaryCardsProps {
  aggregations: ExpenseScenarioAggregations | undefined;
  onCardClick?: (card: SummaryCardType) => void;
}

/**
 * Summary KPI tiles for the Expense Scenarios list page.
 * @param {ExpenseScenariosSummaryCardsProps} props - The component props
 * @return {JSX.Element} The summary cards grid
 */
const ExpenseScenariosSummaryCards: FC<ExpenseScenariosSummaryCardsProps> = ({
  aggregations,
  onCardClick,
}) => {
  return (
    <div className={styles.cardsContainer}>
      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Total Configurations"
          value={formatNumber(
            aggregations?.totalCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last 24 Hours"
          value={formatNumber(
            aggregations?.createdLast24h,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
          onFilterClick={onCardClick ? () => onCardClick('last24h') : undefined}
          filterTooltip="Filter by Created in Last 24 Hours"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last 7 Days"
          value={formatNumber(
            aggregations?.createdLast7d,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
          onFilterClick={onCardClick ? () => onCardClick('last7d') : undefined}
          filterTooltip="Filter by Created in Last 7 Days"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last Month"
          value={formatNumber(
            aggregations?.createdLastMonth,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
          onFilterClick={
            onCardClick ? () => onCardClick('lastMonth') : undefined
          }
          filterTooltip="Filter by Created in Last Month"
        />
      </div>
    </div>
  );
};

export { ExpenseScenariosSummaryCards };
